import script from "./pop-up-email.vue?vue&type=script&setup=true&lang=js"
export * from "./pop-up-email.vue?vue&type=script&setup=true&lang=js"

import "./pop-up-email.vue?vue&type=style&index=0&id=514049de&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-514049de"]])

export default __exports__